import React from 'react'
import { ToastContainer } from 'react-toastify';
import Spinner from '../Spinner/spinner';
import UseEditPromotionalAddOn from './Hooks/useEditPromotionalAddOn';

const EditPromotionalAddon = () => {
    const { spinner, messagePlanEdit } = UseEditPromotionalAddOn()
    return (
        <>
            <ToastContainer />
            <section>
                <div className="cus-padd cusheight">
                    {spinner ? <Spinner /> : null}
                    <header>
                        <h2 className='page-tittle'>
                            Edit promotional message plan
                        </h2>
                        <hr />
                    </header>
                    {console.log(messagePlanEdit.values)}
                    <form className="row g-3 mt-4" onSubmit={messagePlanEdit.handleSubmit}>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Name *</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='planName'
                                onChange={messagePlanEdit.handleChange}
                                value={messagePlanEdit.values.planName}
                            />
                            {messagePlanEdit.touched.planName && messagePlanEdit.errors.planName ? (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                    {messagePlanEdit.errors.planName}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Price *</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='price'
                                onChange={messagePlanEdit.handleChange}
                                value={messagePlanEdit.values.price}
                            />
                            {messagePlanEdit.touched.price && messagePlanEdit.errors.price ? (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                    {messagePlanEdit.errors.price}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Credit *</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='credit'
                                onChange={messagePlanEdit.handleChange}
                                value={messagePlanEdit.values.credit}
                            />
                            {messagePlanEdit.touched.credit && messagePlanEdit.errors.credit ? (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                    {messagePlanEdit.errors.credit}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Description *</label>
                            <textarea
                                className="form-control"
                                id="recipient-name"
                                name="description"
                                rows="4"
                                onChange={messagePlanEdit.handleChange}
                                value={messagePlanEdit.values.description}
                            />

                            {messagePlanEdit.touched.description && messagePlanEdit.errors.description ? (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                    {messagePlanEdit.errors.description}
                                </div>
                            ) : null}
                        </div>
                        <p>* Note : Please fill all the mandatory fields</p>
                        < div>
                            <button type="submit" className="btn btn-primary col-0">Submit</button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    )
}

export default EditPromotionalAddon